<template>
	<div class="block-form">
		<h3>Выбор точки сканирования</h3>
		<rc-select v-if="right_exhib_select" v-model="exhib_selected" :options="exhib_list" @update="updateExhib" />
		<div v-else>{{ exhib_label }}</div>
		<h3 v-if="exhib_selected">Выбор сессии</h3>
		<rc-select v-if="exhib_selected" v-model="event_selected" :options="event_list" @update="updateEvent" />
		<rc-button v-if="event_selected" @click="selectExhib">Выбрать</rc-button>
		<rc-loading v-if="loading" />
	</div>
</template>
	
<script>
import router from '@/router'
import store from '@/store'
import axios from 'axios'


export default {
	name: 'SelectorView',
	data() {
		return {
			right_exhib_select: true,
			exhib_selected: null,
			show_exhib_list: true,
			event_selected: null,
			exhib_list: [
			],
			event_list: [

			],
			loading: true,
		}
	},
	beforeMount() {
		const local_exhib_id = parseInt(localStorage.getItem('exhib_id'), 10)
		if (store.getters.exhib_id || local_exhib_id) {
			this.exhib_selected = store.getters.exhib_id || local_exhib_id
			this.right_exhib_select = false
		}
	},
	mounted() {
		const local_exhib_id = parseInt(localStorage.getItem('exhib_id'), 10)
		if (store.getters.server_info.status) {
			this.actionGetExhibList()
				.then(() => {

					this.exhib_list = store.getters.exhib_list

					this.loading = false
					if (store.getters.exhib_id || local_exhib_id) {
						this.updateExhib(store.getters.exhib_id || local_exhib_id)
					}
				})
				.catch(err => {
					store.dispatch('errorProcessing', err)
				})
		} else if (store.getters.exhib_list && store.getters.event_list) {
			this.loading = false
			this.exhib_list = store.getters.exhib_list
			this.event_list = store.getters.event_list
			this.exhib_selected = store.getters.exhib_id || local_exhib_id
		}
	},
	computed: {
		user_id() {
			const userid = store.getters.user_id
			return userid ? `User ID: ${userid}` : 'User ID is undefined'
		},
		exhib_label() {
			return store.state.state_exhib.label
		}
	},
	methods: {
		addEventListToStorage() {
			localStorage.setItem('event_list', JSON.stringify(this.event_list))
		},
		readEventListFromStorage() {
			this.event_list = JSON.parse(localStorage.getItem('event_list'))
		},
		updateExhib(exhib_id) {
			this.exhib_selected = parseInt(exhib_id, 10)
			const exhib = this.exhib_list.find(exhib_item => exhib_item.id == this.exhib_selected)
			store.commit('setExhib', { id: exhib.id, label: exhib.label })
			this.loading = true
			this.actionGetEventList()
				.then(() => {
					this.event_list = store.getters.event_list
					this.loading = false
				})
		},
		updateEvent(event_id) {
			const selected = parseInt(event_id, 10)
			const selected_event = this.event_list.find(event_item => event_item.id == selected)
			store.commit('setEvent', { id: selected_event.id, label: selected_event.label, start_ts: selected_event.start_ts, end_ts: selected_event.end_ts })
			this.event_selected = selected
		},
		actionGetExhibList() {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: 'https://mobile-dev.expo-stat.ru/api/v2/point',
					data: {
						uuid: store.getters.user_id,
						login: store.getters.user_name,
						point: store.getters.exhib_id,
						session: store.getters.event_id,
						data: []
					}
				}).then((response) => {
					store.commit('update_server_info', {
						status: true,
						status_ts: Date.now()
					})
					if (response.data.command) {
						this.serverCommand(response.data.command)
					}
					if (response.data.result) {
						store.commit('setExhibList', response.data.respons)
						resolve(true)
					}
				}).catch(err => {
					store.commit('update_server_info', {
						status: false,
						status_ts: Date.now()
					})
					store.dispatch('errorProcessing', err)
					reject(err)
				})
			})
		},
		actionGetEventList() {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: 'https://mobile-dev.expo-stat.ru/api/v2/session',
					data: {
						uuid: store.getters.user_id,
						login: store.getters.user_name,
						point: store.getters.exhib_id,
						session: store.getters.event_id,
						data: []
					}
				})
					.then((response) => {
						store.commit('update_server_info', {
							status: true,
							status_ts: Date.now()
						})
						if (response.data.command) {
							this.serverCommand(response.data.command)
						}
						if (response.data.result) {
							store.commit('setEventList', response.data.respons)
							resolve(true)
						} else { }
					})
					.catch(err => {
						store.commit('update_server_info', {
							status: false,
							status_ts: Date.now()
						})
						reject(err)
					})
			})
		},
		selectExhib() {
			router.push({ name: 'scaner' })
		},

		serverCommand(command) {
			// 24.09: обработать команды от сервера
			switch (command) {
				case 'is_unlogined':
					// store.dispatch('serverUnlogin', null)
					store.commit('setUserAprove', false)
					store.commit('setExhib', { id: null, label: null })
					store.commit('setEvent', { id: null, label: null, start_ts: null, end_ts: null })
					router.push({ name: 'login' })
					break;
				case 'set_point':
					store.commit('setExhib', { id: null, label: null })
					router.push({ name: 'exhibSelector' })
					break;
				case 'set_session':
					router.push({ name: 'exhibSelector' })
					break;
				case 'clear_data':
					store.commit('setUserAprove', false)
					store.commit('setExhib', { id: null, label: null })
					store.commit('clearOrderForShipment')
					router.push({ name: 'login' })
					break;
				case 'debug_mode':
					store.commit('switchDebugMode', result)
					break;
			}
		},

		// ---------------------------
		// ---------------------------
	}
}
</script>

<style scoped></style>